export default __webpack_public_path__ + "static/media/jefferson-santos-9SoCnyQmkzI-unsplash.1d5c0fbf.jpg";